import React from "react";
import { Wrapper } from "../HOC";
import { ChatMessages } from "../components";
import Image01 from "../assets/profile.svg";

const Chats = () => {
  return (
    <Wrapper>
      <div className="w-full flex justify-between h-[calc(100vh-110px)] overflow-hidden">
        <div className="w-[30%]">
          <p className="text-xl font-bold pb-10">Chats</p>
          <div>
            <div className="flex justify-between items-center  border-b-2 pb-3">
              <div className="flex items-center gap-4">
                <img src={Image01} alt="" className="h-[50px] w-[50px]" />
                <div>
                  <p className="text-sm font-semibold">Will Knowles</p>
                  <div className="flex items-center gap-2 text-sm">
                    <p>Hey How is your dog?</p>
                    <p>.1min</p>
                  </div>
                </div>
              </div>
              <div className="w-[7px] h-[7px] rounded-full bg-primary" />
            </div>
          </div>
        </div>
        <>
          <ChatMessages />
        </>
      </div>
    </Wrapper>
  );
};

export default Chats;
